module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Confirmação da ação de remover produto")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), (_vm.removesFromMarketplace) ? _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n      Remover o produto fará com que ele seja removido do Placemarket e do Marketplace. Em caso de o marketplace rejeitar a ação, a remoção será abortada.\n    ")]) : _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n      Remover o produto fará com que ele seja retirado apenas do Placemarket da Moovin, mas não surtirá nenhuma alteração no produto no marketplace, ao realizar este processo poderá anunciar o produto novamente, mas o mesmo não receberá atualizações de estoque e preço durante o processo, certifique-se de deletar o anúncio diretamente no marketplace.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n      Tem certeza de que deseja remover o produto " + _vm._s(_vm.productInText) + "?\n    ")]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Sim")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733868b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ModalRemoveProduct.vue
// module id = 3288
// module chunks = 0